class SaveQuoteWrapper extends HTMLElement {
  constructor() {
    super();

    this.handleOpen = (e) => {
      const el = this.querySelector("template").content.children[0];

      const html = el.outerHTML;
      e.target.dispatchEvent(
        new CustomEvent("markup-modal:open", {
          bubbles: true,
          detail: { html, target: "quote-modal" },
        }),
      );
    };
  }

  connectedCallback() {
    document.addEventListener("quote-modal:open", this.handleOpen);
  }

  disconnectedCallback() {
    document.removeEventListener("quote-modal:open", this.handleOpen);
  }
}

if (!customElements.get("save-quote-wrapper")) {
  customElements.define("save-quote-wrapper", SaveQuoteWrapper);
}
